export default {
      id: "icon-more-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-more",
      toString: function () {
        return this.url;
      }
    }